import React, { Component } from 'react'
import { connect } from 'react-redux'
import ViewSupportTicket from './ViewSupportTicket'
import Loading from '../Loading/Loading'
import authSelector from '../../../selectors/authSelector'
import {
  FETCH_SINGLE_SUPPORT_TICKET_REQUEST,
  EDIT_SUPPORT_TICKET_REQUEST,
} from '../../../actions/actions'
import AddSupportTicketForm from './AddSupportTicketForm'
import ViewSupportTicketMeta from './ViewSupportTicketMeta'
import ViewSupportTicketUser from './ViewSupportTicketUser'
import ViewSupportTicketReplies from './ViewSupportTicketReplies'
import * as MabnaButton from '../Button/Button'
import * as helpers from './helpers'
import { createFormData } from '../../../helpers/utility'
import api from '../../../api/api'
import './style.scss'
import { NotificationManager } from 'react-notifications';

const ErrorView = (errors = {}) => {
  const {
    general_errors
  } = errors
  if (!general_errors) return null

  return (<section className='errors-section'>
    <ul>
      {general_errors.map( error => <li>{error}</li> )}
    </ul>
  </section>
  )
}

const isClosed = status => status === 'closed' || status === 'rejected'
class ViewSupportTicketContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      displayAll: false,
      statusUpdated: false,
    }
  }

  componentWillMount() {
    this.fetchTicket()
  }

  componentDidMount() {
    this.updateTicketStatusIfNew()
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      ticket,
    } = prevProps

    if(ticket === undefined && this.props.ticket) {
      this.updateTicketStatusIfNew()
    }
  }


  updateTicketStatusIfNew = () => {
    if( this.isUserManager() && this.isTicketNew() ) {
      return new Promise( () => {
        return api.editSupportTicket(
          this.props.ticket.ticket_code,
          createFormData({
            ticket_status: 'processing'
          })
        ).then(this.onUpdateStatusSuccess)
        .catch(this.onUpdateStatusFailure)
      })
    }
  }

  fetchTicket = () => {
    const { dispatch, userType, params: { ticket_code } } = this.props

    dispatch({
      type: FETCH_SINGLE_SUPPORT_TICKET_REQUEST,
      ticket_code,
      userType,
    })
  }

  onUpdateStatusSuccess = ({ data: data }) => {
    this.fetchTicket()
    NotificationManager.success('بروزرسانی وضعیت تیکت با موفقیت انجام شد')
  }

  onUpdateStatusFailure = (error) => {
    console.log(error)
    NotificationManager.error('خطا در بروزرسانی وضعیت تیکت')
  }

  toggleDisplayAll = () => this.setState({displayAll: !this.state.displayAll})

  isUserManager = () => this.props.userType === 'MANAGER'

  isTicketNew = () => this.props.ticket && helpers.isTicketNew(this.props.ticket.ticket_status)

  render() {
    const {
      isLoading,
      ticket,
      errors,
      userType,
      userId,
    } = this.props

    const formProps = {
      userType,
      replyMode: true,
      ticketCode: ticket && ticket.ticket_code,
    }

    const status = this.state.statusUpdated || (ticket && ticket.ticket_status)

    if ( isLoading ) return <Loading />

    if ( ticket ) {
      return (<div className='view-support-ticket'>
          <ViewSupportTicketMeta ticket={ticket} isUserManager={this.isUserManager()} status={status} />
          {this.isUserManager() && <ViewSupportTicketUser user={ticket.user} />}
          <ViewSupportTicket ticket={ticket} currentUserId={userId} displayAll={this.state.displayAll} />
          {ticket.replies.length > 1 && <div style={{display: 'flex', justifyContent: 'center', margin: '5px auto'}}>
            <MabnaButton.Primary
              onClick={this.toggleDisplayAll}
            >
              { this.state.displayAll? 'نمایش آخرین پاسخ' : 'نمایش همه' }
            </MabnaButton.Primary>
          </div>}
          <ViewSupportTicketReplies ticket={ticket} currentUserId={userId} displayAll={this.state.displayAll} />

          {!isClosed(ticket.ticket_status) && <AddSupportTicketForm {...formProps} />}
        </div>
      )
    }

    return ErrorView(errors)
  }
}

function mapStateToProps(state) {
  return {
    ...authSelector(state),
    ...state.supportTickets
  }
}


export default connect(
  mapStateToProps,
)(ViewSupportTicketContainer)


// WEBPACK FOOTER //
// ./src/components/common/Support/ViewSupportTicketContainer.js